/* eslint-disable import/no-anonymous-default-export */
import { CHANGE_PASSWORD } from "routes/route.constant";
import ChangePassword from "pages/ChangePassword";

export default {
  path: CHANGE_PASSWORD,
  element: ChangePassword,
};
